/** Formily dynamic-model name: matches `POST …/formily/dynamic-model/ServiceDesk%20Ticket/` */
export const SERVICE_DESK_FORMILY_TICKET_MODEL = "ServiceDesk Ticket";

/** Formily dynamic-model: end-user records (`GET …/grid_data/`). */
export const SERVICE_DESK_FORMILY_ENDUSER_MODEL = "ServiceDesk Enduser";

/** Formily dynamic-model name for customer company records (grid / detail). */
export const SERVICE_DESK_FORMILY_CUSTOMER_COMPANY_MODEL =
  "ServiceDesk Customer Company";

/** Formily dynamic-model for adding/listing portal members under a customer company. */
export const SERVICE_DESK_FORMILY_ADD_MEMBER_MODEL = "ServiceDesk Add Member";

/**
 * Field `name` on the member schema that stores the parent company id (grid filter + create payload).
 * If members do not appear scoped to the company, align this with your Formily field name.
 */
export const SERVICE_DESK_ADD_MEMBER_COMPANY_FK_FIELD = "customer_company_id";
